module.exports = __webpack_public_path__ + "static/media/Font Awesome 5 Pro 900.ae451738.otf";